import MODALS from "../constants/modals";

import { useAppSelector } from "../hooks/redux";

import CookieConsentModal from "../modals/CookieConsent";

const ModalManager: React.FunctionComponent<{}> = () => {
    const modals = useAppSelector((state) => state.modals);

    return modals.length === 0 ? null : (
        <>
            {modals.map((modal, index) => {
                switch (modal.type) {
                    case MODALS.CookieConsent:
                        return (
                            <CookieConsentModal
                                key={`modal_${modal.id}`}
                                {...modal}
                            />
                        );
                    default:
                        console.error("Undefined modal component");
                        return null;
                }
            })}
        </>
    );
};

export default ModalManager;
